import {MapperFields} from "utils/mapperFields";

export const FieldNameTranslationIds = {
    [MapperFields.SKU]: 'product.show.modificationLog.fieldName.sku',
    [MapperFields.EXTERNAL_ID]: 'product.show.modificationLog.fieldName.externalId',
    [MapperFields.GENDER]: 'product.show.modificationLog.fieldName.gender',
    [MapperFields.BRAND]: 'product.show.modificationLog.fieldName.brand',
    [MapperFields.TAX_RATE]: 'product.show.modificationLog.fieldName.taxRate',
    [MapperFields.PRIVATE_PRODUCT]: 'product.show.modificationLog.fieldName.privateProduct',
    [MapperFields.PRIVATE_PRICE]: 'product.show.modificationLog.fieldName.privatePrice',
    [MapperFields.CATALOG_ONLY]: 'product.show.modificationLog.fieldName.catalogOnly',
    [MapperFields.HIDDEN_PRICE]: 'product.show.modificationLog.fieldName.hiddenPrice',
    [MapperFields.STATUS]: 'product.show.modificationLog.fieldName.status',
    [MapperFields.NAME]: 'product.show.modificationLog.fieldName.name',
    [MapperFields.DESCRIPTION]: 'product.show.modificationLog.fieldName.description',
    [MapperFields.PRICE]: 'product.show.modificationLog.fieldName.price',
    [MapperFields.OUTLET_PRICE]: 'product.show.modificationLog.fieldName.outletPrice',
    [MapperFields.DISCOUNTED_PRICE]: 'product.show.modificationLog.fieldName.discountedPrice',
    [MapperFields.WEIGHT]: 'product.show.modificationLog.fieldName.weight',
    [MapperFields.ECO_TAX]: 'product.show.modificationLog.fieldName.ecoTax',
    [MapperFields.BARCODE]: 'product.show.modificationLog.fieldName.barcode',
    [MapperFields.ADDITIONAL_DESCRIPTION]: 'product.show.modificationLog.fieldName.additionalDescription',
    [MapperFields.CATEGORIES]: 'product.show.modificationLog.fieldName.categories',
    [MapperFields.CURRENCY]: 'product.show.modificationLog.fieldName.currency',
    [MapperFields.PICTURES]: 'product.show.modificationLog.fieldName.pictures',
    [MapperFields.URL]: 'product.show.modificationLog.fieldName.url',
    [MapperFields.UPC]: 'product.show.modificationLog.fieldName.upc',
    discountedPriceStartDate: 'product.show.modificationLog.fieldName.discountedPriceStartDate',
    discountedPriceEndDate: 'product.show.modificationLog.fieldName.discountedPriceEndDate',
};
